import { render, staticRenderFns } from "./ModalAccountEdit.vue?vue&type=template&id=2b9a2a93&scoped=true"
import script from "./ModalAccountEdit.vue?vue&type=script&lang=js"
export * from "./ModalAccountEdit.vue?vue&type=script&lang=js"
import style0 from "./ModalAccountEdit.vue?vue&type=style&index=0&id=2b9a2a93&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b9a2a93",
  null
  
)

export default component.exports